import { Button, useToast } from '@chakra-ui/react'
import { DownloadIcon } from '@chakra-ui/icons'
import { useLazyQuery } from '@apollo/client'
import moment from 'moment'
import { downloadCsv, rowsToCsv } from 'src/lib/csv'

const CmsTrackingCsvDownloadButton = ({
  query,
  resultKey,
  columns,
  filenamePrefix,
  successLabel,
  size = 'sm',
  colorScheme = 'teal',
}) => {
  const toast = useToast()

  const [fetchExport, { loading }] = useLazyQuery(query, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      const list = data[resultKey] || []
      const csv = rowsToCsv(list, columns)
      const filename = `${filenamePrefix}-${moment().format('YYYY-MM-DD')}.csv`
      downloadCsv(filename, csv)
      toast({
        title: 'Export ready',
        description: `Downloaded ${list.length} ${successLabel}.`,
        status: 'success',
        duration: 4000,
        isClosable: true,
        position: 'top',
      })
    },
    onError: (error) => {
      toast({
        title: 'Export failed',
        description: error.message,
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top',
      })
    },
  })

  return (
    <Button
      variant="outline"
      colorScheme={colorScheme}
      size={size}
      leftIcon={<DownloadIcon />}
      isLoading={loading}
      loadingText="Preparing..."
      onClick={() => fetchExport()}
      flexShrink={0}
    >
      Download CSV
    </Button>
  )
}

export default CmsTrackingCsvDownloadButton
